import { TRPCClientError } from "@trpc/client";

/** Shown when another moderator changed the item after this view loaded. */
export const MODERATION_CONFLICT_MESSAGE = "Statusen har ändrats av någon annan. Listan har laddats om.";
export const isModerationConflict = err => err instanceof TRPCClientError && err.data?.code === "CONFLICT";